import {
  titleUI,
  yesNoUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import CombatOperationServiceDescription from '../../../../components/FormDescriptions/CombatOperationServiceDescription';
import content from '../../../../locales/en/content.json';
import { FULL_SCHEMA } from '../../../../utils/imports';

const TITLE_TEXT = content['service-info--operations-title'];
const INPUT_LABEL = content['service-info--operations-label'];
const ARIA_DESC_TEXT = content['service-info--operations-aria-label'];

const { combatOperationService } = FULL_SCHEMA.properties;

export default {
  uiSchema: {
    ...titleUI(TITLE_TEXT),
    combatOperationService: yesNoUI({
      title: INPUT_LABEL,
      description: CombatOperationServiceDescription,
      headerAriaDescribedby: ARIA_DESC_TEXT,
    }),
  },
  schema: {
    type: 'object',
    properties: { combatOperationService },
  },
};
